export const ROUTES = {
    DASHBOARD: '/dashboard',
    APPLICATIONS: '/applications',
    APPLICATION_DETAIL: '/applications/:ref',
    PRODUCTS: '/products',
    CONTRACTS: '/contracts',
};
